// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Scalars = require("../../../scalars/Scalars.bs.js");
var TanDate = require("../../../reason/common/types/TanDate.bs.js");
var UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
var DateFns = require("date-fns");
var DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Core__Ordering = require("@rescript/core/src/Core__Ordering.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Property__Components = require("../../../reason/clients/components/Property/Property__Components.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var UnselectedUnionMemberError = require("../../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var PropertyPage__ListingDetails = require("../../propertyPage/PropertyPage__ListingDetails.bs.js");
var PropertyWizardRelay__Preview__Shared = require("./PropertyWizardRelay__Preview__Shared.bs.js");
var PropertyWizardFormRelay__Validators__MLSTiming = require("./PropertyWizardFormRelay__Validators__MLSTiming.bs.js");
var PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");
var PropertyWizardRelayPreviewListingDetails_formState_graphql = require("../../../__generated__/PropertyWizardRelayPreviewListingDetails_formState_graphql.bs.js");
var PropertyWizardRelayPreviewListingDetails_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayPreviewListingDetails_localDraft_graphql.bs.js");
var PropertyWizardRelayPreviewListingDetails_previewHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreviewListingDetails_previewHelpers_graphql.bs.js");

var convertFragment = PropertyWizardRelayPreviewListingDetails_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewListingDetails_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewListingDetails_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewListingDetails_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewListingDetails_localDraft_graphql.node, convertFragment, fRef);
}

var DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayPreviewListingDetails_localDraft_graphql.Utils.localDraftPropertyType_decode;

var DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayPreviewListingDetails_localDraft_graphql.Utils.localDraftPropertyType_fromString;

var DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardRelayPreviewListingDetails_previewHelpers_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewListingDetails_previewHelpers_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewListingDetails_previewHelpers_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewListingDetails_previewHelpers_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewListingDetails_previewHelpers_graphql.node, convertFragment$1, fRef);
}

var DisplayHelpersFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

var convertFragment$2 = PropertyWizardRelayPreviewListingDetails_formState_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewListingDetails_formState_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewListingDetails_formState_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewListingDetails_formState_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewListingDetails_formState_graphql.node, convertFragment$2, fRef);
}

var FormStateFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function PropertyWizardRelay__Preview__ListingDetails(props) {
  var onEditForm = props.onEditForm;
  var draft = use(props.draft);
  var formState = use$2(props.formState);
  var displayHelpers = use$1(props.previewHelpers);
  var websiteValid = PropertyWizardFormRelay__Validators__Description.Website.useIsValid(draft.fragmentRefs);
  var onMlsAtValid = PropertyWizardFormRelay__Validators__MLSTiming.OnMLSAt.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  var mlsListingTypeValid = PropertyWizardFormRelay__Validators__MLSTiming.MLSListingType.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  var mlsData = Core__Option.map(displayHelpers.mlsPlan, (function (mlsPlan) {
          switch (mlsPlan.__typename) {
            case "ListOnMlsAsActive" :
                return [
                        Caml_option.some(mlsPlan.onMlsAt),
                        mlsPlan.willShowPriorToMls,
                        mlsPlan.willAcceptOffersPriorToMls
                      ];
            case "ListOnMlsAsComingSoon" :
                return [
                        Caml_option.some(mlsPlan.activeOnMlsOn),
                        mlsPlan.willShowPriorToMls,
                        mlsPlan.willAcceptOffersPriorToMls
                      ];
            case "NoMlsPlan" :
                return [
                        undefined,
                        mlsPlan.willShow,
                        mlsPlan.willAcceptOffers
                      ];
            case "__unselected" :
                return UnselectedUnionMemberError.raise("Unselected MLS Plan " + mlsPlan._0);
            
          }
        }));
  var dateTimeToUnzonedDate = function (x) {
    return UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(x));
  };
  var match = displayHelpers.showings;
  var match$1 = draft.draftProperty.propertyType;
  var tmp;
  tmp = match !== undefined && match$1 === "FOR_SALE" ? Core__Option.getOr(Core__Option.map((function (arr) {
                    arr.sort(function (a, b) {
                          return Core__Ordering.fromInt(dateTimeToUnzonedDate(a.startDate).getTime() - dateTimeToUnzonedDate(b.startDate).getTime() | 0);
                        });
                    return arr;
                  })(Core__Array.keepSome(match).filter(function (showing) {
                          return DateFns.isAfter(dateTimeToUnzonedDate(showing.startDate), TanDate.now());
                        }).slice())[0], (function (showing) {
                return DateFns.format(UTCDate.toZonedDate(Scalars.DateTime.toUTC(showing.startDate), DateFnsTz.Timezone.make(draft.timeZone)), "MMM d 'at' h:mm a");
              })), "None scheduled") : undefined;
  var nextShowing = Core__Option.map(tmp, (function (prim) {
          return prim;
        }));
  var commission = Core__Option.map(draft.draftProperty.commission, (function (prim) {
          return prim;
        }));
  var mlsPreviewErrorMessages = PropertyWizardRelay__Preview__Shared.getMlsPreviewErrorMessages(mlsListingTypeValid, onMlsAtValid, onEditForm);
  var expectedOnMls = mlsPreviewErrorMessages !== undefined ? Caml_option.some(Caml_option.valFromOption(mlsPreviewErrorMessages)) : Core__Option.flatMap(mlsData, (function (param) {
            return Core__Option.map(param[0], (function (date) {
                          return DateFns.format(CalendarDate.toLocalDate(date), "MMM d, YYY");
                        }));
          }));
  var willShowBeforeMls = Core__Option.map(Core__Option.flatMap(mlsData, (function (param) {
              return Core__Option.map(param[1], (function (willShow) {
                            if (willShow) {
                              return "Yes";
                            } else {
                              return "No";
                            }
                          }));
            })), (function (prim) {
          return prim;
        }));
  var willAcceptOffersBeforeMls = Core__Option.map(Core__Option.flatMap(mlsData, (function (param) {
              return Core__Option.map(param[2], (function (willAcceptOffers) {
                            if (willAcceptOffers) {
                              return "Yes";
                            } else {
                              return "No";
                            }
                          }));
            })), (function (prim) {
          return prim;
        }));
  var match$2 = displayHelpers.website;
  var website;
  var exit = 0;
  if (websiteValid !== undefined && typeof websiteValid === "object" && websiteValid.NAME === "Error") {
    website = Caml_option.some(JsxRuntime.jsx(Property__Components.MissingFieldMarker.make, {
              text: "Please enter a valid URL",
              onClick: (function (param) {
                  onEditForm("description");
                })
            }));
  } else {
    exit = 1;
  }
  if (exit === 1) {
    website = Core__Option.map(Core__Option.map(match$2, Scalars.$$URL.toString), (function (website) {
            return JsxRuntime.jsx("a", {
                        children: website,
                        href: website,
                        target: "_blank"
                      });
          }));
  }
  return JsxRuntime.jsx(PropertyPage__ListingDetails.make, {
              timeOnTan: "-",
              commission: commission,
              website: website,
              nextShowing: nextShowing,
              expectedOnMls: expectedOnMls,
              willShowBeforeMls: willShowBeforeMls,
              willAcceptOffersBeforeMls: willAcceptOffersBeforeMls
            });
}

var Validators;

var ListingDetails;

var MissingFieldMarker;

var Shared;

var make = PropertyWizardRelay__Preview__ListingDetails;

exports.Validators = Validators;
exports.ListingDetails = ListingDetails;
exports.MissingFieldMarker = MissingFieldMarker;
exports.Shared = Shared;
exports.DraftFragment = DraftFragment;
exports.DisplayHelpersFragment = DisplayHelpersFragment;
exports.FormStateFragment = FormStateFragment;
exports.make = make;
/* Scalars Not a pure module */
